import { computed } from "vue";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import LogoFull from "./LogoFull.js";
import LogoReduced from "./LogoReduced.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
const style0 = {};
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XLogo",
  components: { LogoFull, LogoReduced }
};
const COLORS = {
  black: "var(--color-neutral-1000)",
  white: "var(--color-neutral-0)",
  orange: "var(--color-brand-primary-400)"
};
const _sfc_main = Object.assign(__default__, {
  props: {
    color: {
      type: String,
      default: "orange",
      validation: (color) => color in COLORS
    },
    height: {
      type: String,
      default: "32px"
    },
    reduced: {
      type: Boolean,
      default: false
    },
    ...createTestIdProp()
  },
  setup(__props) {
    const props = __props;
    const { formatTestId } = setupTestId(props);
    const logoStyles = computed(() => ({
      fill: COLORS[props.color],
      height: props.height
    }));
    const logoModel = computed(() => props.reduced ? "LogoReduced" : "LogoFull");
    return { __sfc: true, createTestIdProp, setupTestId, COLORS, props, formatTestId, logoStyles, logoModel };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.logoModel, { tag: "component", style: _setup.logoStyles, attrs: { "data-testid": _setup.formatTestId() } });
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XLogo = __component__.exports;
export {
  COLORS,
  XLogo as default
};
